var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 531,
    height: 400,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07,
    clipPath: "url(#verify_svg__clip0_2327_5013)",
    fill: "#323234"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 500.014,
    cy: 80.667,
    rx: 30.986,
    ry: 30.333
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 417.782,
    cy: 77.167,
    rx: 32.178,
    ry: 31.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.219,
    cy: 83,
    rx: 26.219,
    ry: 25.667
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 465.453,
    cy: 46.833,
    rx: 41.712,
    ry: 40.833
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07,
    clipPath: "url(#verify_svg__clip1_2327_5013)",
    fill: "#323234"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.348,
    cy: 28.403,
    rx: 29.348,
    ry: 28.403,
    transform: "matrix(-1 0 0 1 58.697 169.232)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.477,
    cy: 29.495,
    rx: 30.477,
    ry: 29.495,
    transform: "matrix(-1 0 0 1 137.711 164.862)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.833,
    cy: 24.033,
    rx: 24.833,
    ry: 24.033,
    transform: "matrix(-1 0 0 1 164.801 175.787)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.507,
    cy: 38.235,
    rx: 39.507,
    ry: 38.235,
    transform: "matrix(-1 0 0 1 101.59 127.72)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.459 374.934h46.109V240.701h-46.109v134.233z",
    fill: "#7DB1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.1 227.15h26.01v-13.555H302.1v13.555z",
    fill: "#3A3B39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.115 294.067h160.012v-55.269H220.115v55.269zM248.445 216.294h133.32v-88.573h-133.32v88.573z",
    fill: "#585755"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.309 210.549h121.595v-77.084H254.309v77.084z",
    fill: "#FFFFFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.398 240.701h202.545v-8.821H210.398v8.821z",
    fill: "#B3E0D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.971 226.203h-41.734a5.675 5.675 0 00-5.675 5.675h53.084a5.675 5.675 0 00-5.675-5.675z",
    fill: "#585755"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.848 382.578h51.582V240.701h-51.582v141.877z",
    fill: "#B3E0D0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.848 248.94h51.582v-8.239h-51.582v8.239z",
    fill: "#7DB1A1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.264 195.015l-40.391-53.579c-4.21-5.59-3.099-13.525 2.491-17.735 5.527-4.185 13.526-3.099 17.736 2.492l20.449 27.132 58.429-75.36c4.269-5.524 12.229-6.52 17.753-2.251 5.529 4.295 6.54 12.248 2.256 17.78l-78.723 101.521z",
    fill: "#00A650"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.422 302.697l2.604 74.787c4.068.291 8.047.861 11.049 1.728a.172.172 0 01-.042-.071l.043.072c.75.216 1.438.451 2.052.705.707.172 1.555.36 2.483.566 4.582 1.015 11.125 2.466 12.397 4.654 1.379 2.375.492 5.968-2.045 7.02-2.591 1.075-5.904-1.345-5.668-4.141.158-1.871 1.858-3.304 3.676-3.602l-7.705-1.394c-.046.732-.54 1.536-1.58 2.416-1.411 1.194-3.409 1.469-5.276 1.726l-.211.029a75.312 75.312 0 01-6.634.613c.622 1.994 1.194 4.877 1.157 5.283-.367 4.048-6.358 7.374-8.345 2.317-.725-1.847.197-3.937 1.686-4.809 1.006-.589 2.269-.623 3.457.348l-1.089-3.04c-5.062.074-10.141-.253-15.181-.728-2.218-.208-4.854-.78-5.94-2.47l-10.093 3.145c1.84.073 3.703 1.286 4.09 3.124.578 2.745-2.413 5.554-5.117 4.806-2.647-.733-3.969-4.19-2.891-6.717.994-2.327 7.309-4.57 11.731-6.141.682-.242 1.32-.468 1.886-.677.592-2.165 3.602-3.666 6.158-4.232 2.542-.563 6.593-.82 10.976-.748l-2.399-68.894c-4.619.273-14.334.001-25.025-5.329-13.275-6.62-30.6-22.651-37.747-61.439l4.882-.899c5.338 28.961 17.382 48.937 34.831 57.768 13.132 6.646 24.906 4.737 25.019 4.718l2.811-.494z",
    fill: "#3A3B39"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.691 206.412c-5.763-3.464-12.706-5.44-18.827-5.82-8.805-.546-18.2 2.637-23.43 9.74-5.937 8.063-4.991 21.006-1.463 29.898 9.424 23.749 51.564 10.905 55.559-11.231 1.837-10.174-3.874-17.801-11.839-22.587zM224.912 293.927s-11.305 15.364-34.36 16.518c-23.054 1.155-48.636-6.584-28.774-25.737 21.054-20.302 63.134 9.219 63.134 9.219z",
    fill: "#523B5D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.924 377.773l-4.256 16.079h17.261l-7.094-6.148 7.094-12.768-13.005 2.837z",
    fill: "#3A3B39"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.129 245.12s103.745-7.33 100.198 29.084c-3.547 36.414-45.4 103.567-45.4 103.567h-13.004l16.245-43.98 8.819-57.459-107.053 1.419 40.195-32.631z",
    fill: "#C40F35"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.66 272.549s3.074 33.576 53.676 27.192c50.601-6.384 78.975-5.675 78.975-5.675l-38.069 87.252h11.361s76.364-91.98 48.699-114.444c-27.666-22.463-116.954-11.823-116.954-11.823l-37.688 17.498z",
    fill: "#E73A5E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.908 144.865l14.194-8.582c-1.801-11.435-3.898-22.838-7.226-33.897l-21.497 5.565c2.326 13.466-48.236 27.725-54.822 11.795-47.022 9.749-4.896 152.805-4.896 152.805l86.73-27.992-12.483-99.694z",
    fill: "#00AEC8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.244 132.571l-7.567-31.685-5.8 1.501c3.328 11.059 5.425 22.462 7.227 33.897l6.14-3.713zM180.06 143.073c14.177-5.156 19.645-21.658 17.319-35.124l-5.223 1.352c2.28 11.98-2.836 23.971-14.771 27.287-14.048 3.782-23.153-6.431-27.95-18.409a337.3 337.3 0 00-6.878 1.565c6.586 15.93 19.043 29.284 37.503 23.329zM156.85 89.393l-1.25 1.996s2.475 3.218 6.431 2.638l.913-1.46-6.094-3.174z",
    fill: "#FFFFFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.907 144.863l-2.778-17.143 6.061 15.158-3.283 1.985z",
    fill: "#F57100"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.061 116.893l8.037-.601a5.013 5.013 0 004.555-5.908l-.446-2.415-17.616-19.464 14.829-18.214 17.937 10.864-.975 3.805c.223.119.715.485 1.747 1.39-.67 2.087-1.702 3.87-4.156 5.105 0 0 2.809 4.335 7.552-1.712.983 1.478 2.838 3.11 2.591 4.673-.497 3.157-4.302 5.939-4.302 5.939l2.444 12.643c3.288-.487 7.02-.992 11.108-1.462-.684 12.885-6.013 25.487-20.531 26.432-12.367.705-21.073-9-22.774-21.075z",
    fill: "#F9B6A8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.207 107.968s-21.001-18.582-19.89-23.559c1.378-6.17 8.145-15.056 8.145-15.056s-4.101-6.33.502-9.687c4.603-3.357 20.12 7.78 6.855 23.155l5.796 6.6-1.705 1.995c-9.954-.11-8.269 8.133.726 5.078l5.165 5.297-5.594 6.177z",
    fill: "#523B5D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.919 82.012a1.34 1.34 0 10-1.693 2.078 1.34 1.34 0 001.693-2.078zM163.88 83.223a.435.435 0 01-.723-.074c-.548-1.056-.574-2.26-.07-3.222a2.82 2.82 0 012.173-1.507.435.435 0 11.11.863 1.94 1.94 0 00-1.513 1.048c-.372.71-.345 1.614.072 2.417a.436.436 0 01-.049.475z",
    fill: "#3A3B39"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.202 94.684a.43.43 0 01-.324.16c-1.72.05-3.45.239-5.14.56a.435.435 0 11-.162-.855 33.69 33.69 0 015.275-.575.436.436 0 01.351.71zM179.814 100.353l-4.01 4.195 4.524-1.539-.514-2.656zM182.26 113.001l1.181 6 2.027-6.461-3.208.461z",
    fill: "#CC395D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.48 210.007c-20.572-.355-91.089 8.141-91.089 8.141l-12.104-46.359-28.855 1.969a9735.436 9735.436 0 0115.313 54.009c8.868 31.66 114.252-11.021 114.252-11.021l7.448 2.837 5.675-3.192-10.64-6.384z",
    fill: "#F9B6A8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.038 163.174l-28.729 3.193s.783 2.721 2.123 7.393l28.855-1.969-2.249-8.617z",
    fill: "#FFFFFE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.39 218.151l-8.154.844 6.966-5.397 1.188 4.553z",
    fill: "#CC395D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.39 244.558l-84.901 34.59-1.829-6.597 86.73-27.993z",
    fill: "#C30F35"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.364 67.936l1.762 1.087 11.007-13.1-1.762-1.088-11.007 13.1zM192.457 75.962l1.118 1.571 20.163-9.78-1.118-1.57-20.163 9.78zM198.132 88.01l.25 1.58 15.356-1.256-.25-1.58-15.356 1.256z",
    fill: "#B3E0D0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.693.627c-2.963-3.31-14.062 7.567-14.062 7.567l5.497 7.093 1.124-.946 1.908 3.31 4.476-2.127 31.212 77.05-23.172 8.31 7.566 31.685s22.936-12.349 33.104-30.267C278.003 79.998 220.656 3.938 217.693.627z",
    fill: "#F9B6A8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.85 92.573l3.074 7.127-7.319-5.605 4.245-1.522zM210.434 14.647l-.362-.61 7.331-4.353-.988-3.401.682-.198 1.14 3.929-7.803 4.633z",
    fill: "#CC395D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.844 15.812l-.413-.578 1.422-1.015-1.541-3.527.65-.283 1.771 4.054-1.889 1.349z",
    fill: "#CC395D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.242 381.321l-8.039 18.68h19.389l-8.276-6.857 8.288-11.823h-11.362z",
    fill: "#3A3B39"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.312 294.069l5.32-10.64-11.704 10.64h6.384z",
    fill: "#008B44"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.622 155.751l-43.832 3.874 6.011 34.986 43.895-4.371-6.074-34.489z",
    fill: "#B3E0D0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.228 159.498l26.016 14.842 15.23-18.487 1.148-.102.193 1.057-12.093 14.679 17.744 17.5.23 1.253-1.069.186-17.951-17.669-3.046 3.697-6.748-3.849-13.984 21.816-1.097.19-.206-1.199 13.86-21.622-19.485-11.115-.18-1.05 1.438-.127z",
    fill: "#3A3B39"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "verify_svg__clip0_2327_5013"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(357 6)",
    d: "M0 0h174v77H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "verify_svg__clip1_2327_5013"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 164.801 127.72)",
    d: "M0 0h164.8v72.1H0z"
  })))));
}
export default SvgVerify;